import { Announcement } from "@mui/icons-material";
import { Button, Tooltip, Badge, Modal, Snackbar} from "@mui/joy";
import { useSelector, useDispatch } from "react-redux";
import react from "react";
import Alert from '@mui/joy/Alert';
import Box from '@mui/joy/Box';
import IconButton from '@mui/joy/IconButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Typography from '@mui/joy/Typography';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ReportIcon from '@mui/icons-material/Report';
import { ModalClose, ModalDialog } from "@mui/joy";

import { useState, useEffect, useRef } from "react";



export default function MessageBoard(){
    const messages = useSelector(state => Object.keys(state.messages).map(key => ({...state.messages[key], key: key})));
    const n = Object.keys(messages).length;
    const dispatch = useDispatch();
    
    const [toastOpen, setToastOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState(null);
    const prevMessagesRef = useRef([]);

    const icons = {
        success : <CheckCircleIcon /> ,
        info: <InfoRoundedIcon />,
        warning: <WarningIcon />,
        danger: <ReportIcon />
    }

    const [open, setOpen] = useState(false);
    if (n === 0 && open) {
        setOpen(false);
    }
    
    // Watch for new danger messages
    useEffect(() => {
        const dangerMessages = messages.filter(msg => msg.color === 'danger');
        const prevDangerMessages = prevMessagesRef.current.filter(msg => msg.color === 'danger');
        
        // Check if there's a new danger message
        if (dangerMessages.length > prevDangerMessages.length) {
            const newMessage = dangerMessages.find(msg => 
                !prevDangerMessages.some(prevMsg => prevMsg.key === msg.key)
            );
            
            if (newMessage) {
                setToastMessage(newMessage);
                setToastOpen(true);
            }
        }
        
        prevMessagesRef.current = messages;
    }, [messages]);

    const warnLevel = messages.reduce((level, msg) => {
        const levels = { 'danger': 3, 'warning': 2, 'info': 1, 'success': 0 };
        return Math.max(level, levels[msg.color] || 0);
    }, 0);

    const colorMap = {
        0: 'primary',
        1: 'warning',
        2: 'danger',
        3: 'danger'
    };

    return  (
    <react.Fragment>
        {/* Toast notification for danger messages */}
        <Snackbar
            open={toastOpen}
            autoHideDuration={4000}
            onClose={() => setToastOpen(false)}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            sx={{
                top: 24,
            }}
        >
            {toastMessage && (
                <Alert
                    sx={{ 
                        alignItems: 'flex-start',
                        minWidth: 400,
                        boxShadow: 'lg',
                        animation: 'slideDown 0.3s ease-out'
                    }}
                    startDecorator={<ReportIcon />}
                    variant="solid"
                    color="danger"
                    endDecorator={
                        <IconButton 
                            variant="plain" 
                            sx={{ color: 'inherit' }}
                            onClick={() => setToastOpen(false)}
                        >
                            <CloseRoundedIcon />
                        </IconButton>
                    }
                >
                    <div>
                        <Typography level="title-md" sx={{ color: 'inherit' }}>
                            {toastMessage.title}
                        </Typography>
                        <Typography level="body-sm" sx={{ color: 'inherit' }}>
                            {toastMessage.message}
                        </Typography>
                    </div>
                </Alert>
            )}
        </Snackbar>

        {/* Message board modal */}
        <Modal open={open} onClose={() => setOpen(false)}>
            <ModalDialog>
                <ModalClose/>
                <Box sx={{ display: 'flex', gap: 2, width: '100%', flexDirection: 'column' }}>
                {messages.map(({ title, color, message, key }) => (
                        <Alert
                        key={title}
                        sx={{ alignItems: 'flex-start' }}
                        startDecorator={icons[color] || <InfoRoundedIcon />}
                        variant="soft"
                        color={color}
                        endDecorator={
                            <IconButton variant="soft" color={color} onClick={ () => dispatch({type: "CLEAR_MESSAGE", payload: key}) }>
                            <CloseRoundedIcon />
                            </IconButton>
                        }
                        >
                        <div>
                            <div>{title}</div>
                            <Typography level="body-sm" color={color}>
                            {message}
                            </Typography>
                        </div>
                        </Alert>
                    ))}
                </Box>
            </ModalDialog>
        </Modal>
        
        {/* Message board button */}
        <Tooltip title="Info messages" placement="top" >
            <Badge color={colorMap[warnLevel]} variant="solid" badgeContent={ n> 0 ? n.toString() : null} anchorOrigin={{vertical: 'top', horizontal: 'left'}}>
                <Button onClick={ () => setOpen(!open)} >
                    <Announcement/>
                </Button>
            </Badge>
        </Tooltip>
    </react.Fragment>
    )
}